<template>
  <vs-row vs-type="flex" vs-w="12" id="CategoryGiroPage">
    <vs-row vs-type="flex" vs-w="12">
      <vs-row vs-type="flex" vs-w="12" class="mb-1">
        <global-filter ref="filterer" :tableOptions="tableOptions" :filterOptions="filterOptions"
          :filterChips="filterChips" :filterOptionNames="filterOptionNames" :isActive="isFilterActive"
          @saveOptions="saveOptions" @close="isFilterActive = false;" />
        <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between">
          <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="flex-start">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Detaylı Filtereleme" position="top">
                  <vs-button @click="isFilterActive = !isFilterActive;"
                    class="panel-action text-warning xlarge-button panel-action-box-shadow" color="transparent"
                    icon-pack="pickicon" icon="icon-pick-filter">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Excel Export" position="top">
                  <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                    color="transparent" icon-pack="feather" icon="icon-download">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col vs-type="flex" class="w-auto">
              <vx-tooltip text="Yazdır" position="top">
                    <vs-button @click="printReport" color="transparent" class="panel-action text-dark xlarge-button panel-action-box-shadow" icon-pack="feather"
                      icon="icon-printer" />
                  </vx-tooltip>
                </vs-col>
            </vs-row>
          </vs-col>
          <vs-col id="filter-chips" vs-type="flex">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
              <vs-button id="clearFilterButton" v-if="filterChips.length > 0" @click="clearFilter"
                class="mr-2 bg-white text-danger panel-action-box-shadow" icon-pack="feather" icon="icon-slash" radius
                color="transparent" />
              <vs-col vs-type="flex" class="w-auto" v-for="(chip,index) in filterChips" :key="index">
                <vs-chip color="white" class="panel-action-box-shadow px-1" @click="removeFilter(chip.col,index)"
                  v-show="chip.value != '' " closable>
                  <vs-row vs-tpye="flex" vs-w="12">
                    <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                      <span class="bold text-xsmaller text-dark">
                        {{chip.name + ' :'}}
                      </span>
                    </vs-col>
                    <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                      <span class="weight-600 italic text-xsmaller text-primary">
                        {{chip.value}}
                      </span>
                    </vs-col>
                  </vs-row>
                </vs-chip>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col id="table-page-size" vs-type="flex" class="w-auto" vs-justify="flex-end">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" vs-w="w-auto">
                <vx-tooltip title="Yenile" :text="toRefreshString + ' içinde yenilenecek.'" position="top">
                  <vs-button @click="refreshNow()"
                    class="panel-action text-primary xlarge-button panel-action-box-shadow" color="transparent"
                    icon-pack="feather" icon="icon-refresh-ccw">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" v-if="reportData && reportData.length > 0">
      <category-giro-min :tableOptions="tableOptions" :stop="true" :reportData="reportData"
        :orderBy="tableOptions.reportByProp ? tableOptions.reportByProp.id : 0 " />
    </vs-row>
  </vs-row>
</template>

<script>
  import GlobalFilter from "../../GlobalFilter";
  import {
    GetCategoryGiro,
    GetCategoryGiroExcel,
    GetCategoryGiroExcelForDealer,
    GetCategoryGiroForDealer
  } from "@/api/Reports.js";
  export default {
    components: {
      GlobalFilter,
      CategoryGiroMin: () => import("./CategoryGiroMin.vue")
    },
    data() {
      return {
        tableOptions: {},
        reportData: null,
        toRefresh: 5 * 60,
        isFilterActive: false,
        filterOptions: ["branch","defaultTimeRange", "dateRange", "timeRange", "daysOfWeek", "reportByProp", "direction"],
        filterOptionNames: ["Şube", "Zaman Aralığı", "Tarih", "Saat", "daysOfWeek", "Ölçüt", "Sıralama"],
        filterChips: []
      }
    },
    computed: {
      toRefreshString() {
        if (this.toRefresh < 60) return this.toRefresh + " Saniye";
        if (this.toRefresh == 60) return "1 Dakika";
        var min = this.toRefresh / 60;
        var sec = this.toRefresh % 60;
        return (min | 0) + " Dakika " + sec + " Saniye";
      },
    },
    mounted() {
      this.doRefresh();
      this.clearFilter();
    },
    methods: {
      getExcel() {
        if (this.$isCenterBranch()) {
          GetCategoryGiroExcel(this.tableOptions).then(res => {
            if (res && res.status == 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let now = this.$now.date();
              link.setAttribute('download', 'Kategori Ciro Raporu' + now.getDate() + " " + this.$months()[now
                  .getMonth()]
                .name + " " + now.getFullYear() + '.xlsx');
              document.body.appendChild(link);
              link.click();

              this.$vs.notify({
                color: "success",
                title: "Başarılı",
                text: "Excel Export Başarılı !"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Excel Export İşlemi Başarısız !"
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !"
            });
          });
        } else if (this.$isRegionalCenterBranch()) {
          GetCategoryGiroExcelForDealer(this.tableOptions).then(res => {
            if (res && res.status == 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let now = this.$now.date();
              link.setAttribute('download', 'Kategori Ciro Raporu' + now.getDate() + " " + this.$months()[now
                  .getMonth()]
                .name + " " + now.getFullYear() + '.xlsx');
              document.body.appendChild(link);
              link.click();

              this.$vs.notify({
                color: "success",
                title: "Başarılı",
                text: "Excel Export Başarılı !"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Excel Export İşlemi Başarısız !"
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !"
            });
          });
        } else {
          GetCategoryGiroExcel(this.tableOptions).then(res => {
            if (res && res.status == 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let now = this.$now.date();
              link.setAttribute('download', 'Kategori Ciro Raporu' + now.getDate() + " " + this.$months()[now
                  .getMonth()]
                .name + " " + now.getFullYear() + '.xlsx');
              document.body.appendChild(link);
              link.click();

              this.$vs.notify({
                color: "success",
                title: "Başarılı",
                text: "Excel Export Başarılı !"
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Excel Export İşlemi Başarısız !"
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !"
            });
          });
        }
      },
      refreshNow() {
        this.toRefresh = 5 * 60;
        this.getCategoryGiro();
      },
      doRefresh() {
        let vm = this;
        setInterval(function () {
          vm.toRefresh--;
        }, 1000);
      },
      saveOptions(filterOptions, filterChips) {
        this.isFilterActive = false;
        if (_.isEqual(this.tableOptions, filterOptions)) return;
        this.tableOptions = _.cloneDeep(filterOptions);
        this.filterChips = _.cloneDeep(filterChips);
      },
      removeFilter(col, index) {
        this.tableOptions[col] = null;
        this.filterChips.splice(index, 1);
      },
      clearFilter() {
        this.tableOptions = {
          reportByProp: 0,
          dateRange: {
            startDate: null,
            endDate: null
          },
          daysOfWeek: null,
          defaultTimeRange: this.$now().getHours() >= 0 && this.$now().getHours() <= 2 ? {
            name: "Yesterday",
            id: 0,
            dName: "Dün"
          } : {
            name: "Today",
            id: 1,
            dName: "Bugün"
          },
          timeRange: {
            startTime: null,
            endTime: null
          },
          branch: null,
          direction: {
            name: "Desc",
            id: 1,
            dName: "Azalan"
          }
        };
        this.filterChips.length = 0;
      },
      getCategoryGiro() {
        if (this.$isCenterBranch()) {
          GetCategoryGiro(this.tableOptions).then(res => {
            if (res && res.status == 200) {
              this.reportData = res.data;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Rapor Hazırlanamadı"
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası"
            });
          });
        } else if (this.$isRegionalCenterBranch()) {
          GetCategoryGiroForDealer(this.tableOptions).then(res => {
            if (res && res.status == 200) {
              this.reportData = res.data;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Rapor Hazırlanamadı"
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası"
            });
          });
        } else {
          GetCategoryGiro(this.tableOptions).then(res => {
            if (res && res.status == 200) {
              this.reportData = res.data;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Rapor Hazırlanamadı"
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası"
            });
          });
        }
      },
      printReport() {
          this.isPrintMode = true;
          this.$nextTick(() => {
const prtHtml = document.getElementById('CategoryGiroPage').innerHTML;

// Get all stylesheets HTML
let stylesHtml = '';
for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
  stylesHtml += node.outerHTML;
}

// Open the print window
const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

WinPrint.document.close();
window.setTimeout(() => {WinPrint.focus(); WinPrint.print(); WinPrint.close();  this.isPrintMode = false;}, 2000)
           // window.location.reload();
          });
        }
    },
    watch: {
      toRefresh(val) {
        if (val != 0) return;
        this.getCategoryGiro();
        this.toRefresh = 5 * 60;
      },
      tableOptions: {
        deep: true,
        handler(val) {
          this.$nextTick(() => {
            this.getCategoryGiro();
          });
        }
      },
    }
  }

</script>

<style>

</style>
